<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:45vh; margin-left:40vw;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<div class="col-12 d-flex flex-row justify-content-center" id="top-div">
  <div class="col-3 mr-4">
    <div class="ui-inputgroup inputClass">
      <button pButton class="theme-button noHover labelButton" style="padding: 0.2rem;" type="button" label="Plate ID"></button>
      <input pInputText id="sample-placement-input" name="SearchPlate" [(ngModel)]="samplePlacementPlateID" size="10" (keydown.enter)="checkPlateForSamplePlacement()" class="inputFields" [disabled]="disableSamplePlacementPlateIDField"/>
      <button pButton class="search-field-blue-end" icon="fa fa-times" (click)="resetField()"></button>
    </div>
  </div>
  <div class="col-3 ml-4">
    <div class="ui-inputgroup inputClass">
      <input type="text" class="sample-pos" [value]="selectedCell" readonly>
      <input pInputText type="text" class="scan-barcode" id="barcode-scanner" placeholder="Scan Barcode" [(ngModel)]="scannedBarcode" (keydown.enter)="checkAndPlaceSample()" [disabled]="isSampleSelectionOn">
    </div>
  </div>
</div>
<div *ngIf="showPlateView" class="col-12" id="plate-view">
  <table id="scanTable" aria-describedby="View Plates" class="table">
    <thead>
      <tr class="row100 head">
        <th class="column100 column1" scope="col"></th>
        <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index">
          {{col}} </th>
      </tr>
    </thead>
    <tbody>
      <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
        <td class="column100 column1">{{row}}</td>
        <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%;">
          <input class="cellviewsold" [ngClass]="determineClassForDifferentSampleBarcodes(i,j)" pInputText
            type="text" (click)="selectSample(i,j)" [value]="getSampleAt(i, j).sampleID"
            [pTooltip]="getSampleAt(i, j).sampleID" tooltipPosition="top" readonly />
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="col-12 d-flex flex-row justify-content-around">
  <div *ngIf="showPlateView" class="col-6 d-flex flex-row justify-content-around">
    <button pButton *ngIf="!isSampleSelectionOn" class="buttonsRound" label="Select Samples" (click)="turnOnSampleSelection()"></button>
    <button pButton *ngIf="isSampleSelectionOn" class="buttonsRound" label="Clear Selection" (click)="turnOffSampleSelection()"></button>
    <button pButton *ngIf="isSampleSelectionOn" class="buttonsRound removeSamples" label="Remove Sample" [disabled]="disableRemoveSamplesButton()" (click)="removeSamples()"></button>
  </div>
  <div class="col-6 d-flex flex-row justify-content-center">
    <button pButton label="Close" icon="fa fa-times" class="buttonsRound" (click)="closePopUp()"></button>
  </div>
</div>

<p-dialog header="Please select a sample" showEffect="fade" position="top"
    [(visible)]="duplicateSamplesPresent" [modal]="true"
    [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues($event)">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View samples" class="table">
        <tbody>
          <tr>
            <th>Sample ID</th>
            <th>SampleType</th>
            <th>Activated</th>
            <th>Gender</th>
            <th>Announced</th>
            <th></th>
          </tr>
          <tr *ngFor="let sample of allSelectedSamples; let i=index">
            <td>{{sample.barCode}}</td>
            <td>{{sample.sampleType}}</td>
            <td>{{sample.activated? "Yes" : "No"}}</td>
            <td>{{sample.gender}}</td>
            <td>{{sample.announcedDate | date: 'dd.MM.yy'}}</td>
            <td>{{sample.receptionStatus === 'REMOVED' ? "Yes (" + sample.receptionIssueReason + ")" : "No" }}</td>
            <td>{{sample.sampleCompletionDate !== null ? ("Yes (" + (sample.sampleCompletionDate | date: 'dd.MM.yy') + ")") : "No"}}</td>
            <td>
              <button [disabled]="checkIfSampleIsDisabledForSelection(sample)" class="removeMargin buttonsRound endButton ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" (click)="selectedSampleFromScan(sample)">Select Sample</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</p-dialog>

<p-dialog header="Sample Check Failed!" [(visible)]="showSampleCheckFailedDialog" [modal]="true" position="top">
  <div class="col-12 flex sample-check-content">
    <br/>
    <h5> {{ sampleCheckErrorMessage }} </h5>
    <br/>
    <h5> Please set the sample aside. </h5>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeSampleCheckFailedDialog()"></button>
  </div>
</p-dialog>
